<!--
CercleDigital InsiderGems, gestion électronique documentaire partagée de l'écosystème Cercle.
Copyright 2026 Pierre-Thibault Fabre <pierre-thibault@cercle.digital>
SPDX-License-Identifier: LicenseRef-Cercle-Interne

Fichier : apps/web/src/AvertissementAppareil.vue
Rôle : avertit sur un appareil non pris en charge, sans bloquer l'utilisateur.
Référence : designsystem.md ; CIG-SPECIFICATION.md §5.4 point 5.
-->
<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { LARGEUR_MINIMALE_PRISE_EN_CHARGE } from '@cig/design-system';

const trop_petit = ref(false);
const passeOutre = ref(false);

function mesurer(): void {
  trop_petit.value = window.innerWidth < LARGEUR_MINIMALE_PRISE_EN_CHARGE;
}

onMounted(() => {
  passeOutre.value = window.sessionStorage.getItem('cig.appareil.passeOutre') === 'oui';
  mesurer();
  window.addEventListener('resize', mesurer);
});
onUnmounted(() => window.removeEventListener('resize', mesurer));

function continuer(): void {
  window.sessionStorage.setItem('cig.appareil.passeOutre', 'oui');
  passeOutre.value = true;
}
</script>

<template>
  <div v-if="trop_petit && !passeOutre" class="avertissement" role="alertdialog" aria-modal="true">
    <div class="cig-carte">
      <h1>Appareil non pris en charge</h1>
      <p class="cig-discret">
        Cet écran est plus étroit que ce que l'interface prend en charge.
        L'affichage risque d'être inexploitable.
      </p>
      <p><button @click="continuer">Continuer malgré tout</button></p>
    </div>
  </div>
</template>

<style scoped>
.avertissement {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  place-items: center;
  padding: var(--cig-espace-3);
  background: var(--cig-fond);
}
</style>
